export default __webpack_public_path__ + "static/media/MICHAEL.2cf54552.png";